import React, { createContext, useContext, useState, useEffect } from 'react';

const ModeContext = createContext();

export const ModeProvider = ({ children }) => {
  const [mode, setModeState] = useState('solve'); // 'solve' or 'invest'

  useEffect(() => {
    // Priority: URL param > localStorage > default
    const urlParams = new URLSearchParams(window.location.search);
    const urlMode = urlParams.get('mode');
    const storedMode = localStorage.getItem('mode');
    
    if (urlMode && (urlMode === 'solve' || urlMode === 'invest')) {
      setModeState(urlMode);
      localStorage.setItem('mode', urlMode);
    } else if (storedMode && (storedMode === 'solve' || storedMode === 'invest')) {
      setModeState(storedMode);
    }
  }, []);

  const setMode = (newMode) => {
    setModeState(newMode);
    localStorage.setItem('mode', newMode);
    
    // Update URL param
    const url = new URL(window.location);
    url.searchParams.set('mode', newMode);
    window.history.pushState({}, '', url);
  };

  const toggleMode = () => {
    const newMode = mode === 'solve' ? 'invest' : 'solve';
    setMode(newMode);
    
    // Track mode switch
    if (window.gtag) {
      window.gtag('event', 'mode_switch', {
        from: mode,
        to: newMode
      });
    }
  };

  return (
    <ModeContext.Provider value={{ mode, setMode, toggleMode }}>
      {children}
    </ModeContext.Provider>
  );
};

export const useMode = () => {
  const context = useContext(ModeContext);
  if (!context) {
    throw new Error('useMode must be used within ModeProvider');
  }
  return context;
};
